import styled from "styled-components";

export const Card = styled.div<{ dragging?: boolean }>`
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px 16px 40px;
  margin-bottom: 14px;
  position: relative;
  box-shadow: ${({ dragging }) =>
    dragging ? "0 10px 25px rgba(0,0,0,.15)" : "0 4px 12px rgba(0,0,0,.06)"};
  transition: box-shadow 0.2s ease;
`;

export const DragHandle = styled.div`
  position: absolute;
  left: 12px;
  top: 22px;
  cursor: grab;
  color: #9ca3af;
  font-size: 18px;

  &:hover {
    color: #4f46e5;
  }
`;

export const ActionBtn = styled.button<{ danger?: boolean }>`
  position: absolute;
  top: 10px;
  right: ${({ danger }) => (danger ? "10px" : "46px")};
  border: none;
  background: ${({ danger }) => (danger ? "#fee2e2" : "#eef2ff")};
  color: ${({ danger }) => (danger ? "#dc2626" : "#4f46e5")};
  border-radius: 8px;
  padding: 4px 8px;
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  margin-bottom: 10px;

  &:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 90px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);
  }
`;

export const Footer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
`;

export const Btn = styled.button<{ primary?: boolean }>`
  padding: 10px 18px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  background: ${({ primary }) =>
    primary ? "linear-gradient(135deg,#6366f1,#2563eb)" : "#f3f4f6"};
  color: ${({ primary }) => (primary ? "#fff" : "#111827")};

  &:hover {
    opacity: 0.9;
  }
`;
